import SecureLS from "secure-ls";
const ls = new SecureLS({ encodingType: 'aes', isCompression: true });

export const getItem = (value) => {
  return ls.get(value);
};

export const setItem = (valueKey, value) => {
  ls.set(valueKey, value);
};

export const destroyItem = (valueKey) => {
  ls.remove(valueKey);
};

export const destroyStorage = () => {
  ls.removeAll();
};

export default { getItem, setItem, destroyItem, destroyStorage };
